"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProseList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const react_string_replace_1 = __importDefault(require("react-string-replace"));
const constants_1 = require("./constants");
const prose_list_style_1 = __importDefault(require("./prose.list.style"));
class ProseList extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.parseBoldMarkdown = item => react_string_replace_1.default(item, constants_1.PROSE_REGEX_MARKDOWN_BOLD, (match, i) => (jsx_runtime_1.jsx("strong", { children: match }, `bold_${i}`)));
        this.renderItems = () => {
            const { classes, items } = this.props;
            return items.map((item, i) => (jsx_runtime_1.jsx("li", Object.assign({ className: classes.item }, { children: this.parseBoldMarkdown(item) }), `item_${i}`)));
        };
        this.render = () => {
            const { classes, breakAfter, small, light, ordered } = this.props;
            const rootProps = {
                className: classes.root,
                'data-break-after': breakAfter,
                'data-is-small': small,
                'data-is-light': light,
                'data-is-ordered': ordered
            };
            if (ordered)
                return jsx_runtime_1.jsx("ol", Object.assign({}, rootProps, { children: this.renderItems() }), void 0);
            return jsx_runtime_1.jsx("ul", Object.assign({}, rootProps, { children: this.renderItems() }), void 0);
        };
    }
}
exports.ProseList = ProseList;
ProseList.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    items: prop_types_1.default.array.isRequired,
    breakAfter: prop_types_1.default.bool,
    small: prop_types_1.default.bool,
    light: prop_types_1.default.bool,
    ordered: prop_types_1.default.bool
};
ProseList.defaultProps = {
    breakAfter: false,
    small: false,
    light: false,
    ordered: false
};
exports.default = react_jss_1.default(prose_list_style_1.default)(ProseList);
//# sourceMappingURL=prose.list.js.map